import { IconButton } from '@festina-life/ui/actions'
import { useTranslate } from '@festina-life/ui/hooks'
import { paperStyles } from '@festina-life/ui/libs'
import cx from 'classnames'
import type { MouseEvent } from 'react'
type Props = {
  onCancel: (event: MouseEvent) => void
  onSave: (event: MouseEvent) => void | Promise<void>
  className?: string
}

export const EditorButtonGroup = ({ onCancel, onSave, className }: Props) => {
  const translate = useTranslate()

  return (
    <div
      className={cx('absolute flex flex-row justify-end gap-x-1', className)}
    >
      <IconButton
        tip={translate('cancel')}
        iconName="ArrowUturnLeft"
        onClick={onCancel}
        className={cx('rounded-md', paperStyles({ isFaded: true }))}
      />
      <IconButton
        tip={translate('save')}
        iconName="Check"
        onClick={onSave}
        className={cx('rounded-md', paperStyles({ isFaded: true }))}
      />
    </div>
  )
}
